var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "c-object__development__button",
      attrs: { id: _vm.image.id }
    },
    [
      _c(
        "a",
        {
          ref: "objectCard",
          staticClass: "c-object__development",
          attrs: { href: _vm.image.url, tabindex: _vm.linkTabindex }
        },
        [
          _c("div", { staticClass: "c-object__development__imagearea" }, [
            _c("picture", [
              _c("source", {
                attrs: {
                  srcset: _vm.image.tabletImageUrl,
                  media: "(min-width:372px) and (max-width:770px)"
                }
              }),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src: _vm.image.imageUrl,
                  alt: _vm.image.text,
                  title: _vm.image.text
                }
              })
            ]),
            _vm._v(" "),
            _vm.image.labelText
              ? _c(
                  "div",
                  {
                    staticClass: "c-object__development__labelarea",
                    style: "background-color: " + _vm.image.labelColor
                  },
                  [
                    _c(
                      "p",
                      { staticClass: "c-object__development__labelarea--text" },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.image.labelText) +
                            "\n\t\t\t\t"
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "c-object__development__labelarea--circle"
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.image.imageText
              ? _c(
                  "div",
                  { staticClass: "c-object__development__statusarea" },
                  [
                    _c(
                      "p",
                      {
                        staticClass: "c-object__development__statusarea--text"
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.image.imageText) +
                            "\n\t\t\t\t"
                        )
                      ]
                    )
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "c-object__development__textarea" }, [
            _c("div", [
              _vm.headingLevel === "h2"
                ? _c(
                    "h2",
                    { staticClass: "c-object__development__scroller--heading" },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(_vm.image.text) + "\n\t\t\t\t"
                      )
                    ]
                  )
                : _c(
                    "h3",
                    { staticClass: "c-object__development__scroller--heading" },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(_vm.image.text) + "\n\t\t\t\t"
                      )
                    ]
                  ),
              _vm._v(" "),
              _vm.image.subText
                ? _c(
                    "p",
                    { staticClass: "c-object__development__scroller--text2" },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.image.subText) +
                          "\n\t\t\t\t\t"
                      ),
                      _vm.image.size
                        ? _c("span", [_vm._v(_vm._s(_vm.image.size))])
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.image.preamble
                ? _c(
                    "p",
                    {
                      staticClass: "c-object__development__scroller--preamble"
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm.image.preamble.length > 125
                              ? _vm.image.preamble.substring(0, 125) + "..."
                              : _vm.image.preamble
                          ) +
                          "\n\t\t\t\t"
                      )
                    ]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "c-object__development__link" },
              [
                _c("span", {
                  staticClass: "accessible-a",
                  attrs: { "aria-label": _vm.image.text, "aria-hidden": "true" }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "t-visually-hidden" }, [
                  _vm._v(_vm._s(_vm.image.text))
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.readMoreLabel))]),
                _vm._v(" "),
                _c("v-icon", {
                  attrs: { name: _vm.getIcon(_vm.image.url), size: "xxs" }
                })
              ],
              1
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }